import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import { FEATURE_FLAGS } from "../../../constants/FeatureFlag";
import useFeatureFlag from "../../../hooks/useFeatureFlag";
import * as auth from "../_redux/authRedux";
import LegacyLogin from "./Login/LegacyLogin";
import NewLogin from "./Login/NewLogin";

function Login(props) {
  const { isFeatureFlagEnable, flagResolved } = useFeatureFlag(
    FEATURE_FLAGS.KILL_SWITCH.ENABLE_FIRST_ACCESS_FLOW
  );

  if (!flagResolved) {
    return null;
  }

  return isFeatureFlagEnable ? (
    <NewLogin {...props} />
  ) : (
    <LegacyLogin {...props} />
  );
}

export { Login as UnconnectedLogin };
export default injectIntl(connect(null, auth.actions)(Login));
